import { SHEET_W_MM, SHEET_H_MM } from './geometry';

export const MARK_OFFSET_MM = 3;
export const MARK_LEN_MM = 5;
export const MARK_STROKE_MM = 0.15;
export const REG_MARK_RADIUS_MM = 1.5;

export type LineSegment = { x1: number; y1: number; x2: number; y2: number };
export type CornerMark = { segments: [LineSegment, LineSegment] };

/**
 * Four corner crop marks: each is two perpendicular short lines
 * offset MARK_OFFSET_MM from the sheet edge, MARK_LEN_MM long.
 * Order: TL, TR, BL, BR.
 */
export function cornerCropMarks(): CornerMark[] {
  const w = SHEET_W_MM;
  const h = SHEET_H_MM;
  const o = MARK_OFFSET_MM;
  const l = MARK_LEN_MM;
  return [
    // Top-left
    { segments: [
      { x1: 0, y1: o, x2: l, y2: o },
      { x1: o, y1: 0, x2: o, y2: l },
    ] },
    // Top-right
    { segments: [
      { x1: w - l, y1: o, x2: w, y2: o },
      { x1: w - o, y1: 0, x2: w - o, y2: l },
    ] },
    // Bottom-left
    { segments: [
      { x1: 0, y1: h - o, x2: l, y2: h - o },
      { x1: o, y1: h - l, x2: o, y2: h },
    ] },
    // Bottom-right
    { segments: [
      { x1: w - l, y1: h - o, x2: w, y2: h - o },
      { x1: w - o, y1: h - l, x2: w - o, y2: h },
    ] },
  ];
}

export type RegistrationMark = { cx: number; cy: number; r: number };

/** Two registration marks: top-centre and bottom-centre, in the margin area. */
export function registrationMarks(): RegistrationMark[] {
  return [
    { cx: SHEET_W_MM / 2, cy: MARK_OFFSET_MM + REG_MARK_RADIUS_MM, r: REG_MARK_RADIUS_MM },
    { cx: SHEET_W_MM / 2, cy: SHEET_H_MM - MARK_OFFSET_MM - REG_MARK_RADIUS_MM, r: REG_MARK_RADIUS_MM },
  ];
}
